"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_1ieme1k74y() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomVersionTwo.tsx";
  var hash = "8d1edf8f364b75877ffc01c61ad07be22be0bfd0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/BathroomVersionTwo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 60
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8d1edf8f364b75877ffc01c61ad07be22be0bfd0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ieme1k74y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ieme1k74y();
var Icon = (cov_1ieme1k74y().s[0]++, {
  name: 'bathroom-version-two',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.785 2.01475C16.2185 2.44831 16.2185 3.15125 15.785 3.58481L9.594 9.77576C9.51895 10.6315 10.2451 11.3488 11.0897 11.2781L17.2837 5.08408C17.7173 4.65052 18.4202 4.65052 18.8538 5.08408C19.2874 5.51764 19.2874 6.22058 18.8538 6.65414L12.6701 12.8379C12.6158 13.7258 13.3632 14.4772 14.2566 14.4206L20.4379 8.23935C20.8715 7.80579 21.5744 7.80579 22.008 8.23935C22.4415 8.67291 22.4415 9.37585 22.008 9.80941L15.5717 16.2457C15.5602 16.2572 15.5484 16.2685 15.5366 16.2794L13.2471 18.5688C12.0024 19.8135 10.1788 20.2221 8.55182 19.6837L6.38834 21.8472C5.95478 22.2808 5.25184 22.2808 4.81828 21.8472L2.43137 19.4603C1.99781 19.0267 1.99781 18.3238 2.43137 17.8902L4.57256 15.7491C3.89949 13.965 4.31381 11.916 5.69891 10.5309L6.81202 9.41774L6.82185 9.40779L14.2149 2.01475C14.6485 1.58119 15.3514 1.58119 15.785 2.01475ZM7.78698 11.5829C8.3239 12.5875 9.32378 13.3133 10.4844 13.4726C10.6606 14.6634 11.4147 15.6823 12.4503 16.2255L11.6771 16.9987C10.9295 17.7463 9.77815 17.9107 8.8512 17.4022C8.40809 17.1591 7.85771 17.2377 7.50033 17.5951L5.60331 19.4921L4.78646 18.6753L6.6816 16.7801C7.04991 16.4118 7.12161 15.8406 6.85576 15.3927C6.22498 14.33 6.39509 12.9748 7.26897 12.1009L7.78698 11.5829Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;